// extracted by mini-css-extract-plugin
export default {"radio":"style_radio__ycy4B"};